exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.buttons-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 24px;\n  padding: 15px;\n}\ndiv.buttons-group button {\n  cursor: pointer;\n  border: none;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: 0.464286px;\n  font-size: 13px;\n  background: #FFFFFF;\n  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.237602), 0 0 8px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  margin: 0 4px;\n  color: #156879;\n  width: 93px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases-tools/cases-tools.component.less
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases-tools/cases-tools.component.less
// module chunks = main